import { camel2snake as changeCase } from '../text/lettercase';

export const camelToSnake = (obj: unknown): unknown  => {
    if(obj != null && (typeof obj) == 'object') {
        if(Array.isArray(obj)) {
            return obj.map(camelToSnake);
        } else {
            const result = {};
            for(const [key, value] of Object.entries(obj)) {
                result[changeCase(key)] = camelToSnake(value);
            }
            return result;
        }
    } else {
        return obj;
    }
}
export default camelToSnake;
